import { useSearchParams } from 'react-router-dom';

type SearchParamsType = ReturnType<typeof useSearchParams>;

export enum Paths {
  // PUBLIC
  LOGIN = '/login',
  LOGOUT = '/logout',
  CALENDAR_CONNECTION_SUCCESSFUL = '/public/calendar/success',
  CALENDAR_CONNECTION_FAILURE = '/public/calendar/failure',
  EMAIL_OPT_OUT_SUCCESS = '/public/email/opt-out/success',
  EMAIL_OPT_OUT_FAILURE = '/public/email/opt-out/failure',
  // HOME
  HOME = '/home',
  HOME_TEAM = '/home/team',
  HOME_CALENDAR_MEETINGS = '/home/meetings',
  HOME_DOCUMENTS = '/home/documents',
  HOME_USAGE = '/home/usage',
  HOME_CHANNELS = '/home/channels',
  // Calendar meetings
  CALENDAR_MEETING_TEMPLATE_CREATE = '/home/meetings/templates/create',
  CALENDAR_MEETING_TEMPLATE_EDIT = '/home/meetings/templates/edit',
  CALENDAR_MEETING_TEMPLATE_PREVIEW = '/home/meetings/templates/preview',
  CALENDAR_ADD_CONTACT = '/home/meetings/add-contact',
  // SETTINGS
  ONBOARDING = '/onboarding',
  PROFILE = '/profile',
  ADMINISTRATOR = '/administrator',
  ADMINISTRATOR_ACCOUNTS_OVERVIEW = '/administrator/accounts-overview',
  RESET_PASSWORD = '/password/reset',
  INVITE = '/invite',
  // Campaigns
  CAMPAIGN = '/campaign',
  CAMPAIGNS = '/campaigns',
  OUTBOUND_CAMPAIGN = '/campaign/outbound',
  CAMPAIGN_CREATE_DRAFT = '/campaign/outbound/create',
  CAMPAIGN_ADD_CSV_CANDIDATES = '/campaign/outbound/add',
  CAMPAIGN_OUTBOUND_OPENING_MESSAGES = '/campaign/outbound/opening-messages',
  CAMPAIGN_AUTOMATION = '/campaign/automation',
  CAMPAIGN_CREATE_WITH_PARTICIPANTS = '/campaign/create-with-participants',
  CAMPAIGN_CREATE_WITH_PARTICIPANTS_REVIEW = '/campaign/create-with-participants/review',
  CAMPAIGN_CREATE_WITH_PARTICIPANTS_SELECT_CAMPAIGN = '/campaign/create-with-participants/select',
  // Analyses
  ANALYSE = '/ranks',
  ANALYSE_CREATE = '/ranks/create',
  ANALYSE_ADD_CV = '/ranks/add-cv',
  //Templates
  ANALYSE_TEMPLATES = '/ranks/templates',
  ANALYSE_TEMPLATE_CREATE = '/ranks/templates/create',
  //Rulesets
  ANALYSE_RULESETS = '/ranks/rulesets',
  ANALYSE_RULESET_CREATE = '/ranks/rulesets/create',
  ANALYSE_RULESET_ADD_JOBS = '/ranks/rulesets/add-jobs',
  /** @deprecated use ANALYSE */
  CANDIDATES_RANKING = '/ranks',
  /** @deprecated use ANALYSE_RULESETS */
  CANDIDATES_RANKING_GROUP = '/group/ranks',
  /** @deprecated use ANALYSE_RULESET_CREATE */
  CANDIDATES_RANKING_GROUP_CREATE = '/group/create',
  // MISC
  CONTACT_SUPPORT = '/contact-support',
  CHANNELS = '/channels'
}

export const updateSearchParams = ({
  searchParams,
  newParam,
  setSearchParams
}: {
  searchParams: SearchParamsType[0];
  newParam: {
    key: string;
    value: string;
  };
  setSearchParams: SearchParamsType[1];
}) => {
  const newParams = new URLSearchParams(searchParams);
  newParams.set(newParam.key, newParam.value);
  setSearchParams(newParams.toString(), {
    state: {
      shallow: true
    },
    replace: true
  });
};

export const deleteSearchParams = ({
  searchParams,
  key,
  setSearchParams
}: {
  searchParams: SearchParamsType[0];
  key: string;
  setSearchParams: SearchParamsType[1];
}) => {
  const newParams = new URLSearchParams(searchParams);
  newParams.delete(key);
  setSearchParams(newParams.toString(), {
    state: {
      shallow: true
    },
    replace: true
  });
};

export const deleteBulkSearchParams = ({
  searchParams,
  keys,
  setSearchParams
}: {
  searchParams: SearchParamsType[0];
  keys: string[];
  setSearchParams: SearchParamsType[1];
}) => {
  const newParams = new URLSearchParams(searchParams);
  keys.forEach((key) => {
    newParams.delete(key);
  });
  setSearchParams(newParams.toString(), {
    state: {
      shallow: true
    },
    replace: true
  });
};
